import { ButtonView, Plugin } from "ckeditor5";

export default class MyMediaGallery extends Plugin {
    init() {
        const editor = this.editor;

        // Add a custom button for media gallery
        editor.ui.componentFactory.add("mediaGallery", (locale) => {
            const button = new ButtonView(locale);

            button.set({
                label: "گالری تصویر",
                tooltip: true,
                withText: true,
            });

            button.on("execute", () => {
                const mediaGalleryCallback = editor.config.get("mediaGallery") as (
                    callback: (imageUrl: string) => void
                ) => void;

                if (mediaGalleryCallback) {
                    mediaGalleryCallback((imageUrl: string) => {

                        if (imageUrl) {
                            // Insert the selected image into the editor
                            editor.model.change((writer) => {
                                const imageElement = writer.createElement("imageBlock", {
                                    src: imageUrl,
                                });
                                editor.model.insertContent(
                                    imageElement,
                                    editor.model.document.selection
                                );
                            });
                        } else {
                            console.error("No image URL received.");
                        }
                    });
                } else {
                    console.error("Media gallery callback is not defined!");
                }
            });

            return button;
        });
    }
}